import { api } from "@app/data/index";
import { PrintDoc, Printer, PrintJob, User } from "@lemmonhq/types";
import { ToastContextType } from "@app/vue/providers/Toast";
import { getErrorWithTag } from "..";
import { nanoid } from "nanoid";
import { getTaxRcptPrintJobId } from "@app/utils/clientBusiness";

export type ShopConnection = {
  unsubscribe: () => void;
  print: (job: PrintJob) => Promise<any>;
  printReceipt: (doc: PrintDoc) => Promise<any>;
  pingPrinters: Function;
};

export function createShopConnection(
  sessionId: string,
  user: User,
  printers: Printer[],
  toast: ToastContextType,
  onPrinterPing: (printerId: number, isOnline: boolean) => void,
): ShopConnection {
  console.log("createShopConnection", sessionId);

  const printersPingWorker = async () => {
    await Promise.all(
      printers.map(async (printer) => {
        const online = await api.pingPrinter(printer);
        onPrinterPing(printer.id, !!online);
      }),
    );
  };
  let printersPingIntervel: ReturnType<typeof setInterval> | null = setInterval(
    printersPingWorker,
    25000,
  );
  printersPingWorker();

  return {
    pingPrinters: printersPingWorker,
    unsubscribe: () => {
      if (printersPingIntervel) {
        clearInterval(printersPingIntervel);
        printersPingIntervel = null;
      }
      console.log("ShopConnection unsubscribed");
    },
    printReceipt: async (doc: PrintDoc) => {
      const matchingPrinters = printers.filter(
        (el) => el.user_ids.includes(user.id) && el.print_receipt,
      );
      if (matchingPrinters.length == 0) {
        toast.showToast(
          `No Receipt printer configured for ${user.profile.name}`,
          {
            type: "warning",
            icon: "print_error",
          },
        );
        throw getErrorWithTag("NO_RECEIPT_PRINTER", user);
      }
      const promises = matchingPrinters.map(async (printer) => {
        const job: PrintJob = {
          doc,
          printerId: printer.id,
        };
        const printJobId = nanoid();
        console.log(`printJobId = ${printJobId}`);
        try {
          await api.printJob(printers, job, user, printJobId);
        } catch (e) {
          console.error(e);
          throw e;
          //          toast.showToast(`Failed Printing ${job.doc.type}`, {
          //            type: "warning",
          //            icon: "print_error",
          //          });
          //throw getErrorWithTag("PRINT_RECEIPT_FAILED", user);
        }
      });
      return await Promise.all(promises);
    },
    print: async (job: PrintJob) => {
      try {
        // Kitchen tickets are tracked under their docId, the id the server
        // recorded them under in print_job_statuses.
        const printJobId =
          job.doc.type === "kitchenTicket" && job.doc.docId
            ? job.doc.docId
            : nanoid();
        console.log(`printJobId = ${printJobId}`);
        await api.printJob(printers, job, user, printJobId);
      } catch (e) {
        console.error(e);
        throw e;
        //        toast.showToast(`Failed Printing ${job.doc.type}`, {
        //          type: "warning",
        //          icon: "print_error",
        //        });
        //        throw getErrorWithTag("PRINT_FAILED", user);
      }
    },
  };
}
